export default "__VITE_ASSET__BIHRIbW0__"